export enum PaymentMethod {
    Card = "card",
    US_Bank_Account = "us_bank_account",
    ApplePay = "apple_pay",
    GooglePay = "google_pay",
}
